import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ListAltOutlined from '@mui/icons-material/ListAltOutlined';
import { Box } from '@mui/material';
import type { MouseEventHandler } from 'react';
import { useNavigate } from 'react-router';
import Button from '@/components/Buttons/Button';
import { SHOW_SELECTED_URL_PARAM, SPOT_CATALOG_PATH } from '@/constants/constants';
import { useAppDispatch } from '@/hooks/redux-hooks';
import { closeDrawer } from '@/slices/drawerSlice';

const ButtonGroup = ({ onClearAll }: { onClearAll: MouseEventHandler<HTMLButtonElement> }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleViewInCatalog = () => {
    navigate(`/catalog/${SPOT_CATALOG_PATH}?${SHOW_SELECTED_URL_PARAM}=true`);
    dispatch(closeDrawer());
  };

  return (
    <Box sx={{ display: 'flex', gap: 2 }}>
      <Button
        onClick={onClearAll}
        startIcon={<DeleteOutlineIcon />}
        sx={{
          fontSize: 14,
          width: 123,
          height: 30,
          backgroundColor: 'gx.actionBarButtonTile'
        }}
      >
        Clear All
      </Button>
      <Button
        onClick={handleViewInCatalog}
        startIcon={<ListAltOutlined />}
        sx={{
          fontSize: 14,
          width: 144,
          height: 30,
          backgroundColor: 'gx.actionBarButtonTile'
        }}
      >
        View in catalog
      </Button>
    </Box>
  );
};

export default ButtonGroup;
